
export const RESIZE_DELAY = 5000;
export const MOBILE_BREAKPOINT = 600;

// Example dummy data structure for api.marketrack.in/topPrices response
// ...existing code...
export const dummyResponse = {
  topPrices: [
    {
      name: "RELIANCE",
      current: {
        value: 2456.75,
        time: new Date("2025-10-06"),
      },
      prev: {
        value: 2400.5,
      },
      change: 56.25,
    },
    {
      name: "TCS",
      current: {
        value: 3567.8,
        time: new Date("2025-09-27T09:30:00"),
      },
      prev: {
        value: 3600.2,
      },
      change: -32.4,
    },
    {
      name: "HDFCBANK",
      current: {
        value: 1678.9,
        time: new Date("2025-09-27T09:30:00"),
      },
      prev: {
        value: 1665.3,
      },
      change: 13.6,
    },
    {
      name: "INFY",
      current: {
        value: 1456.25,
        time: new Date("2025-09-27T09:30:00"),
      },
      prev: {
        value: 1445.75,
      },
      change: 10.5,
    },
  ],
  status: "Open",
  occasion: "Regular Trading Day",
};